import { createSlice } from '@reduxjs/toolkit';

// Type
const initialState = {
  selectedRoundData: {},
  showRoundDrawer: false,
};

const rubberDuckRoundDrawerSlice = createSlice({
  name: 'rubberDuckRoundDrawer',
  initialState,
  reducers: {
    setShowRoundDrawer: (state, { payload }) => {
      state.showRoundDrawer = payload;
    },
    setSelectedRound: (state, { payload }) => {
      state.selectedRoundData = payload;
    },
  },
});

export const { reducer: rubberDuckRoundDrawerReducer } = rubberDuckRoundDrawerSlice;
export const { setShowRoundDrawer, setSelectedRound } = rubberDuckRoundDrawerSlice.actions;
